import { loadMessages } from '@/plugins/i18n.js';

const { locale, locales } = window.config;

export default {
    state: async () => {
        const storedLocale = localStorage.getItem('locale') || locale;
        await loadMessages(storedLocale);

        return {
            locale: storedLocale,
            locales,
        };
    },

    getters: {
        locale: state => state.locale,
        locales: state => state.locales,
    },

    actions: {
        setLocale({ commit }, { locale }) {
            commit('SET_LOCALE', { locale });

            localStorage.setItem('locale', locale);
        },
    },

    mutations: {
        SET_LOCALE(state, { locale }) {
            state.locale = locale;
        },
    },
};
